import React from "react";
import { ExportButton } from "components/buttons";
import { getEmissionsAllocationCSV } from "api";

export const ExportCSVButton = ({ allocationId }: { allocationId: number }) => (
    <ExportButton
        exportFunction={getEmissionsAllocationCSV}
        exportParams={allocationId}
        exportText="Export CSV"
        exportingText="Exporting CSV..."
        successMessage="CSV exported successfully."
        sx={{
            borderRadius: "8px",
            width: '204px',
            height: '36px',
            marginRight: '11px',
            fontWeight: 500
        }}
    />
);